import { useTranslation } from 'react-i18next';
import { CompareStatusMode } from '../utils';

type UseGetButtonTextParams = {
  mode: CompareStatusMode;
};

export const useGetButtonText = ({ mode }: UseGetButtonTextParams): string => {
  const { t } = useTranslation();

  if (!mode) {
    return '';
  }

  const BUTTON_TEXT_KEYS = {
    added: t('ui.compare.status-button-go-to'),
    removed: t('ui.compare.status-button-revert'),
    error: t('ui.compare.status-button-retry'),
    alert: t('ui.compare.status-button-go-to-list'),
  } as const;

  const textKey = BUTTON_TEXT_KEYS[mode];
  return textKey ? textKey : '';
};
